export const DRIVE_OFF = "Drive Off";
export const IOU = "IOU";
export const PREPAY="PREPAY";
export const STOLEN_PLATE='STOLEN PLATE';
export const BASE_URL = process.env.REACT_APP_SERVICES_URL || "";
export const APP_SERVICES_URL = process.env.REACT_APP_APP_SERVICES_URL || "";